/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from 'axios';
import { type TypeCommon } from '../types/common';
import moment from 'moment';
import { SYSTEM_CONSTANT } from '../constants/common.constants';

export const isJsonObject = (strData: TypeCommon): boolean => {
  try {
    JSON.parse(strData);
  } catch (e) {
    return false;
  }
  return true;
};

export const handleError = (
  error: AxiosError<TypeCommon>,
  rejectWithValue: (value: unknown) => TypeCommon,
  includeStatus?: boolean
): TypeCommon => {
  const err: AxiosError<TypeCommon> = error;
  if (!err.response) {
    throw err;
  }
  if (includeStatus) return rejectWithValue(err.response || err.message);
  return rejectWithValue(err.response.data || err.message);
};

export const formatDate = (date: TypeCommon, format?: string): string => {
  if (!date || !moment(date).isValid()) {
    return '';
  }
  moment.updateLocale('ja', {
    weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
  });
  moment.weekdaysShort();
  return moment(new Date(date)).format(
    format ?? SYSTEM_CONSTANT.SYSTEM_LOCAL_DATE_FORMAT
  );
};

export const formatDateUTC = (date: TypeCommon, format?: string): string => {
  if (!date || !moment(date).isValid()) {
    return '';
  }
  moment.updateLocale('ja', {
    weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
  });
  moment.weekdaysShort();
  // const isoString = new Date(date).toISOString();
  // const timeZoneOffset = isoString.slice(-6);
  return moment(new Date(date))
    .utcOffset(9)
    .format(format ?? SYSTEM_CONSTANT.SYSTEM_LOCAL_DATE_FORMAT);
};
